/**
 * @title vendor.js: sub-module for vendor integration
 * @description This module is used to integrate with third-party vendors
 * @dependency
 */
define([], function() {
	
	var Vendor = {
			
		initProductPage : function() {
			document.addEventListener("CostcoSubModulesLoaded", COSTCO.Vendor.initProductDetailIntegrations, false);
		},
		
		initProductDetailIntegrations : function(){
			COSTCO.Vendor.initWebCollage();
			if(!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !$('#order-details-wrapper').length > 0){
				COSTCO.Vendor.initBazaarVoice();
			}
		},
		narvarScriptLoaded: false,
		bvInitialized: false,
		/**
		 * First gets the bazaar voice script (from BazaarVoiceSetup.jspf) and
		 * then initializes the global configuration (using product id) and displays
		 * summary (stars at top) and reviews (in ProductInfo.jsp accordion). There is
		 * a promise when calling $BV.ui that when resolved, binds custom functionality
		 * on BV buttons.
		 * @return {[void]}
		 */
		initBazaarVoice : function() {
			if (typeof bazaar_voice_src != "undefined" && !COSTCO.Vendor.bvInitialized) {
				COSTCO.Vendor.bvInitialized = true;			
				
				var bvUserToken = $.cookie('bvUserToken');

				bvUserToken = typeof bvUserToken == 'undefined' || bvUserToken === null || bvUserToken == '' || bvUserToken == '""' 
					? "" : bvUserToken

				//SFSTRY0036927 - user shouldn't be able to add review as guest
				if(bvUserToken !== "" && !COSTCO.util.getMemberCookie().signedIn) {
					$.removeCookie('bvUserToken');
					bvUserToken = "";
				}
				// BV to check for user authentication
				// Create the bv:userToken meta element
				const bvAuth = document.createElement('meta');
				bvAuth.name = 'bv:userToken';
				bvAuth.content = bvUserToken;
				
				// Append it to the head of the page
				document.head.appendChild(bvAuth);
				
				$.cachedScript(bazaar_voice_src);
			}
		},
		
		initWebCollage : function () {
			console.log('initWebCollage called');
			if(typeof wcJS != 'undefined'){
				console.log('invoking WebCollage JS '+wcJS);
				$.cachedScript(wcJS)
				.done(function() {
					console.log('WebCollage JS loaded');
					Webcollage.loadContent(wcLocalization, wcCpi, {autoPlayAndStop: true});
					console.log('WebCollage JS function called');
				});
			}
		}

	} //End Vendor object
	
	if(typeof window.COSTCO == 'undefined'){
		window.COSTCO = new Object();
	}
	
	window.COSTCO.Vendor = Vendor;
	
    return Vendor;
	
});


// WEBPACK FOOTER //
// ./js/global/vendor.js